<template>
  <div class="footer">
    <p>2020 Tempus.</p>
  </div>
</template>

<script>
export default {
  name: "Footer"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footer {
  padding-top: 26px;
  padding-bottom: 42px;
  background: #2c2228;
}

p {
  margin: auto;
  text-align: center;
  font-family: "Raleway Light", "Montserrat", "Gill Sans", "Gill Sans MT",
    Calibri, "Trebuchet MS", sans-serif;
}
</style>